export const SUPPORTED_LOCALES = ['en', 'hi', 'ta', 'te', 'bn'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  hi: 'हिन्दी',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  bn: 'বাংলা',
};

export const LOCALE_NATIVE_LABELS: Record<Locale, string> = {
  en: 'English',
  hi: 'हिन्दी (Hindi)',
  ta: 'தமிழ் (Tamil)',
  te: 'తెలుగు (Telugu)',
  bn: 'বাংলা (Bengali)',
};

export function isLocale(value: string | undefined): value is Locale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function detectLocaleFromPath(pathname: string): { locale: Locale; rest: string } {
  const match = pathname.match(/^\/([a-z]{2})(\/.*)?$/);
  if (match) {
    const candidate = match[1];
    if (isLocale(candidate)) {
      return { locale: candidate, rest: match[2] ?? '/' };
    }
  }
  return { locale: DEFAULT_LOCALE, rest: pathname };
}

export function stripLocale(pathname: string): string {
  return detectLocaleFromPath(pathname).rest;
}

export function withLocale(locale: Locale, path: string): string {
  const base = path.startsWith('/') ? path : `/${path}`;
  if (locale === DEFAULT_LOCALE) return base;
  return `/${locale}${base === '/' ? '' : base}`;
}
